<mat-card>
  <mat-card-header>
    <mat-card-title>Gestión de {{ 'Tenant' | translate }}</mat-card-title>
    <mat-card-subtitle></mat-card-subtitle>
  </mat-card-header>

  <mat-card-content>

    <mat-label *ngIf="isValidating"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
    <mat-label *ngIf="isSearching"><i class="fa fa-spinner fa-spin"></i> Buscando...</mat-label>
    <mat-label *ngIf="!isSearching && msgError?.length > 0">{{msgError}}</mat-label>

    <div *ngIf="!isSearching && item != null">

      <ng-container *ngIf="canAdd || canEdit">

        <form [formGroup]="formGroup">

          <mat-expansion-panel [expanded]="true">

            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon style="margin-top: -3px;">settings</mat-icon> Datos Generales
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <div fxLayout="row stretch" fxLayout.xs="column">

              <div fxFlex=100 fxFlex.xs=100 class="flex-item" align="Center" *ngIf="!tenantImageChanged()">
                <a target="_blank" href="{{item?.LogoUrl}}">
                  <img src="{{item?.LogoUrl}}" style="height: 100px; width: 100px; border-radius: 100%;">
                </a>
              </div>
              <div fxFlex=100 fxFlex.xs=100 class="flex-item" align="Center" *ngIf="tenantImageChanged()">
                <img src="{{tenantImageBase64}}" style="height: 100px; width: 100px; border-radius: 100%; margin-bottom: 10px;">
              </div>
              <div fxFlex=100 fxFlex.xs=100 class="flex-item" align="Center">
                <button type="button" mat-raised-button (click)="fileInput.click()">Cambiar Imagen</button>
                <input hidden type="file" (change)="convertFileToBase64($event)" #fileInput type="file" color="primary">
              </div>

            </div>

            <hr style="margin:20px 0px; width: 100%;">

            <div fxLayout="row stretch" fxLayout.xs="column">

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Nombre*</mat-label>
                  <input matInput formControlName="Nombre" (keyup.enter)="onGuardar()" maxlength="150">
                  <mat-error *ngIf="!formGroup.controls['Nombre'].valid && formGroup.controls['Nombre'].touched">
                    {{ getErrorNombre() }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Nombre Corto</mat-label>
                  <input matInput formControlName="NombreCorto" (keyup.enter)="onGuardar()" maxlength="150">
                </mat-form-field>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>CUIT</mat-label>
                  <input matInput formControlName="NroDocumento" (keyup.enter)="onGuardar()" maxlength="100">
                </mat-form-field>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label *ngIf="!isTipoResponsableSearching">Tipo Resp. IVA</mat-label>
                  <mat-label *ngIf="isTipoResponsableSearching">Cargando...</mat-label>
                  <mat-select formControlName="TipoResponsableIvaId">
                    <mat-option *ngFor="let s of tipoResponsableList" [value]="s.Id">{{s.Nombre}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="checkGestionConsorcio()">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Nro. Mat. RPA</mat-label>
                  <input matInput formControlName="NumeroMatriculaRpa" (keyup.enter)="onGuardar()" maxlength="50">
                  <mat-error *ngIf="!formGroup.controls['NumeroMatriculaRpa'].valid && formGroup.controls['NumeroMatriculaRpa'].touched">
                    {{ getErrorNumeroMatriculaRpa() }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Teléfono</mat-label>
                  <input matInput formControlName="Telefono" (keyup.enter)="onGuardar()" maxlength="150">
                </mat-form-field>
              </div>

              <div fxFlex=100 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Dirección</mat-label>
                  <input matInput formControlName="Direccion" (keyup.enter)="onGuardar()" maxlength="300">
                </mat-form-field>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Email</mat-label>
                  <input matInput formControlName="Email" type="email" (keyup.enter)="onGuardar()" maxlength="255">
                </mat-form-field>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Sitio Web</mat-label>
                  <input matInput formControlName="SitioWeb" (keyup.enter)="onGuardar()" maxlength="255">
                </mat-form-field>
              </div>

            </div>

            <div fxLayout="row stretch" fxLayout.xs="column">
              <div fxFlex=33.33 fxFlex.xs=100 class="flex-item">
                <mat-checkbox [(ngModel)]="item.Activo" [ngModelOptions]="{standalone: true}" (keyup.enter)="onGuardar()" color="primary">Activo</mat-checkbox> 
              </div>
            </div>

          </mat-expansion-panel>

          <!-- MODULOS HABILITADOS -->
          <ng-container *ngIf="canAdminEdit">

            <br/>

            <mat-expansion-panel [expanded]="true">

              <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-icon style="margin-top: -3px;">lock</mat-icon> Módulos Habilitados
                </mat-panel-title>
                <mat-panel-description>
                </mat-panel-description>
              </mat-expansion-panel-header>

              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label *ngIf="!isFeatureFlagSearching">Módulos Habilitados</mat-label>
                <mat-label *ngIf="isFeatureFlagSearching">Cargando...</mat-label>
                <mat-select formControlName="FeatureFlags" multiple [compareWith]="compareFeatureFlags">
                  <mat-option *ngFor="let s of featureFlagList" [value]="s.Id">{{s.Nombre}}</mat-option>
                </mat-select>
              </mat-form-field>

            </mat-expansion-panel>

          </ng-container>

        </form>

        <ng-container *ngIf="canAdminEdit">

          <br/>

          <!-- DICCIONARIO DE ENTIDADES -->
          <mat-expansion-panel [expanded]="false">

            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon style="margin-top: -3px;">bookmark</mat-icon> Diccionario de Entidades
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="isTenantDiccionarioSearching">
              <mat-label><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
            </div>
            
            <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="!isTenantDiccionarioSearching">
              <ejs-grid #tenantDiccionarioGrid [dataSource]='tenantDiccionarioList' [toolbar]='toolbarOptions' [selectionSettings]='selectionOptions' 
                [allowResizing]='true' [allowSorting]="true" [allowPaging]="true" [pageSettings]='pageSettings' [allowFiltering]='true'
                (actionFailure)="onGridActionFailure($event)">
                  <e-columns>
                    <e-column field='Key' headerText='Entidad' width=90></e-column>
                    <e-column field='NombreMostrar' headerText='Nombre a Mostrar' width=90></e-column>
                  </e-columns>
                  <ng-template #rowTemplate let-data>
                    <tr class="e-row">
                      <td class="e-rowcell" style="text-align: center; padding: 3px 0px;">
                        {{data.Key}}
                      </td>
                      <td class="e-rowcell" style="text-align: center; padding: 3px 0px;">
                        <input matInput [(ngModel)]="data.NombreMostrar" name="NombreMostrar" maxlength="100" (change)="onTenantDiccionarioFieldChange(data.Key, $event)" 
                          style="padding: 4px 2px; width: 90%; border: 1px black solid; text-align: left;">
                      </td>
                    </tr>
                  </ng-template>
                </ejs-grid>
            </div>

          </mat-expansion-panel>

          <br/>

          <!-- MENUES ASOCIADOS AL TENANT -->
          <mat-expansion-panel [expanded]="false">

            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon style="margin-top: -3px;">lock</mat-icon> Menues Asociados {{getMenuHeaderText()}}
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="isMenuTenantSearching">
              <mat-label><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
            </div>

            <!-- <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="!isMenuTenantSearching" style="margin-bottom: 10px;">
              <div fxFlex=100 fxFlex.xs=100 class="flex-item" fxLayoutAlign="end center">
                <mat-checkbox [(ngModel)]="seleccionarTodosMenues" (change)="onMenuSeleccionarTodos($event)" color="primary">Seleccionar todos</mat-checkbox> 
              </div>
            </div> -->
            
            <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="!isMenuTenantSearching">
              <ejs-grid #menuTenantGrid [dataSource]='menuTenantList' [toolbar]='toolbarOptions' [selectionSettings]='selectionOptions' [allowFiltering]='true'
                [allowResizing]='true' [allowSorting]="true" [allowPaging]="true" [pageSettings]='pageSettings' (actionFailure)="onGridActionFailure($event)">
                <e-columns>
                  <e-column field='MenuFuncionCodigo' [filter]='{ operator: "contains" }' headerText='Cód. Menú' width=90></e-column>
                  <e-column field='MenuFuncionNombre' [filter]='{ operator: "contains" }' headerText='Nombre Menú' width=90></e-column>
                  <e-column field='Nombre' [filter]='{ operator: "contains" }' headerText='Nombre' width=90></e-column>
                  <e-column field='Orden' headerText='Orden' [allowFiltering]='false' width=40></e-column>
                  <e-column field='Icono' headerText='Icono' [allowFiltering]='false' width=40></e-column>
                  <e-column field='Asociado' headerText='Asociado?' [allowFiltering]='false' width=40></e-column>
                </e-columns>
                <ng-template #rowTemplate let-data>
                  <tr class="e-row">
                    <td class="e-rowcell" style="text-align: center; padding: 3px 0px;">{{data.MenuFuncionCodigo}}</td>
                    <td class="e-rowcell" style="text-align: center; padding: 3px 0px;">{{data.MenuFuncionNombre}}</td>
                    <td class="e-rowcell" style="text-align: center; padding: 3px 0px;">
                      <input matInput [(ngModel)]="data.Nombre" (change)="onMenuTenantFieldChange(data.MenuFuncionId, 'Nombre', data.Nombre)" 
                        style="padding: 4px 2px; width: 90%; border: 1px black solid; text-align: left;">
                    </td>
                    <td class="e-rowcell" style="text-align: center; padding: 3px 0px;">
                      <input matInput type="number" [(ngModel)]="data.Orden" (change)="onMenuTenantFieldChange(data.MenuFuncionId, 'Orden', data.Orden)" 
                        style="padding: 4px 2px; width: 90%; border: 1px black solid; text-align: right;">
                    </td>
                    <td class="e-rowcell" style="text-align: center; padding: 3px 0px;">
                      <input matInput [(ngModel)]="data.Icono" (change)="onMenuTenantFieldChange(data.MenuFuncionId, 'Icono', data.Icono)" 
                        style="padding: 4px 2px; width: 90%; border: 1px black solid; text-align: left;">
                    </td>
                    <td class="e-rowcell" style="text-align: center; padding: 3px 0px;">
                      <mat-checkbox [(ngModel)]="data.Asociado" (change)="onMenuTenantFieldChange(data.MenuFuncionId, 'Asociado', data.Asociado)" color="primary"></mat-checkbox> 
                    </td>
                  </tr>
                </ng-template>
              </ejs-grid>
            </div>

          </mat-expansion-panel>

        </ng-container>

      </ng-container>

      <ng-container *ngIf="!canAdd && !canEdit && !canAdminEdit">

        <mat-expansion-panel [expanded]="true">

          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon style="margin-top: -3px;">settings</mat-icon> Datos Generales
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div fxLayout="row stretch" fxLayout.xs="column">
            <div fxFlex=100 fxFlex.xs=100 class="flex-item" align="Center" *ngIf="!tenantImageChanged()">
              <a target="_blank" href="{{item?.LogoUrl}}">
                <img src="{{item?.LogoUrl}}" style="height: 100px; width: 100px; border-radius: 100%;">
              </a>
            </div>
            <div fxFlex=100 fxFlex.xs=100 class="flex-item" align="Center" *ngIf="tenantImageChanged()">
              <img src="{{tenantImageBase64}}" style="height: 100px; width: 100px; border-radius: 100%; margin-bottom: 10px;">
            </div>
          </div>

          <hr style="margin:20px 0px; width: 100%;">

          <div fxLayout="row stretch" class="zb-readonly">

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Nombre</b>: {{item.Nombre}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Nombre Corto</b>: {{item.NombreCorto}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Nro. Doc.</b>: {{item.NroDocumento}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Tipo Resp. IVA</b>: {{item.TipoResponsableIvaNombre}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="checkGestionConsorcio()">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Nro. Matr. RPA</b>: {{item.NumeroMatriculaRpa}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Dirección</b>: {{item.Direccion}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Teléfono</b>: {{item.Telefono}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Email</b>: {{item?.Email}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Sitio Web</b>: <a href="{{item?.SitioWeb}}" target="_blank">{{item?.SitioWeb}}</a></mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Activo</b>: {{item.Activo ? 'Sí' : 'No'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

          </div>

        </mat-expansion-panel>

        <ng-container *ngIf="canAdminEdit">

          <br/>

          <mat-expansion-panel [expanded]="true">

            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon style="margin-top: -3px;">lock</mat-icon> Módulos Habilitados
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="isSearching">
              <mat-label><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
            </div>

            <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="!isSearching">
              <ejs-grid #modulosGrid [dataSource]='item?.FeatureFlags' [toolbar]='toolbarOptions' [selectionSettings]='selectionOptions' 
                [allowResizing]='true' [allowSorting]="true" (actionFailure)="onGridActionFailure($event)">
                  <e-columns>
                    <e-column field='Nombre' headerText='Módulo Habilitado' width=90></e-column>
                  </e-columns>
                </ejs-grid>
            </div>

          </mat-expansion-panel>

          <br/>

          <mat-expansion-panel [expanded]="false">

            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon style="margin-top: -3px;">bookmark</mat-icon> Diccionario de Entidades
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="isTenantDiccionarioSearching">
              <mat-label><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
            </div>
            
            <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="!isTenantDiccionarioSearching">
              <ejs-grid #tenantDiccionarioGrid [dataSource]='tenantDiccionarioList' [toolbar]='toolbarOptions' [selectionSettings]='selectionOptions' 
                [allowResizing]='true' [allowSorting]="true" (actionFailure)="onGridActionFailure($event)">
                <e-columns>
                  <e-column field='Key' headerText='Entidad' width=90></e-column>
                  <e-column field='NombreMostrar' headerText='Nombre a Mostrar' width=90></e-column>
                </e-columns>
                <ng-template #rowTemplate let-data>
                  <tr class="e-row">
                    <td class="e-rowcell" style="text-align: center;">{{data.Key}}</td>
                    <td class="e-rowcell" style="text-align: center;">{{data.NombreMostrar}}</td>
                  </tr>
                </ng-template>
              </ejs-grid>
            </div>

          </mat-expansion-panel>

          <br/>

          <mat-expansion-panel [expanded]="false">

            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon style="margin-top: -3px;">lock</mat-icon> Menues Asociados {{getMenuHeaderText()}}
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="isMenuTenantSearching">
              <mat-label><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
            </div>

            <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="!isMenuTenantSearching">
              <ejs-grid #menuTenantGrid [dataSource]='menuTenantList' [allowPaging]="true" [allowSorting]="true" [toolbar]='toolbarOptions' [selectionSettings]='selectionOptions' 
                [pageSettings]='pageSettings' [allowResizing]='true' (actionFailure)="onGridActionFailure($event)">
                <e-columns>
                  <e-column field='MenuFuncionCodigo' headerText='Cód. Menú' width=90></e-column>
                  <e-column field='MenuFuncionNombre' headerText='Nombre Menú' width=90></e-column>
                  <e-column field='Nombre' headerText='Nombre' width=90></e-column>
                  <e-column field='Orden' headerText='Orden' width=40></e-column>
                  <e-column field='Icono' headerText='Icono' width=40></e-column>
                  <e-column field='Asociado' headerText='Asociado?' width=40>
                    <ng-template #template let-data>
                      {{data.Asociado ? 'Sí' : 'No'}}
                    </ng-template>
                  </e-column>
                </e-columns>
              </ejs-grid>
            </div>

          </mat-expansion-panel>

        </ng-container>

      </ng-container>

    </div>

  </mat-card-content>

  <mat-card-actions style="margin-bottom: 20px;">
    <div fxLayout="row stretch" fxLayout.xs="column">
      <button mat-raised-button (click)="onGuardar()" *ngIf="item != null && (canAdd || canEdit)" [disabled]="isProcessing()" color="primary" class="zb-button">{{isSaving ? 'Guardando...' : 'Guardar'}}</button>
      <button mat-raised-button (click)="onCancel()" color="warn" class="zb-button">{{canAdd || canEdit ? 'Cancelar' : 'Cerrar'}}</button>
      <button mat-raised-button (click)="onDelete()" *ngIf="item != null && canDelete" color="warn" class="zb-button">{{isDeleting ? 'Eliminando...' : 'Eliminar'}}</button>
    </div>
  </mat-card-actions>

</mat-card>